import React, { useEffect, useState, useCallback, Fragment } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Menu, Transition, Dialog, Popover, Switch } from "@headlessui/react";
import clsx from "clsx";
import axios from "axios";
import { captchaUrl, apiBaseUrl } from "../../services/http";
import Layout from "../../layouts";
import libNoImage from "../../images/campus-lib-f.jpg";
import Breadcrumb from "../../components/Breadcrumb";
import { useIndividualStore } from "../../store";
import Declaration from "./Declaration";

export default function RenewLogin() {
  const [captcha, setCaptcha] = useState(null);
  const store = useIndividualStore();
  const [loginForm, setLoginForm] = useState({
    username: "",
    email: "",
    captcha: "",
    captchaKey: "",
    mType: "individual",
    appType: "renew",
  });
  const [auth, setAuth] = useState({
    status: "idle",
    data: null,
    error: null,
  });

  const fetchCaptcha = useCallback(async () => {
    const response = await axios.get(captchaUrl);
    setCaptcha(response.data);
    setLoginForm((loginForm) => ({
      ...loginForm,
      captcha: "",
      captchaKey: response.data.key,
    }));
  }, []);

  useEffect(() => {
    store.clearForm();
  }, []);

  useEffect(() => {
    fetchCaptcha();
  }, [fetchCaptcha]);

  // useEffect(() => {
  //   if (auth.status === "succeeded" && auth.data?.email) {
  //     navigate(`/alumni/app/renew/declaration`);
  //   }
  // }, [navigate, auth]);

  useEffect(() => {
    if (auth.status === "failed") {
      fetchCaptcha();
    }
  }, [auth, fetchCaptcha]);

  const onUpdateField = (field, value) =>
    setLoginForm((data) => ({
      ...data,
      [field]: value,
    }));

  const onSubmit = (e) => {
    e.preventDefault();

    const loginMyAccount = async () => {
      setAuth({
        status: "pending",
        data: null,
        error: null,
      });
      try {
        const response = await axios.post(
          `${apiBaseUrl}/myaccount`,
          loginForm,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        setAuth({
          status: "succeeded",
          data: response.data,
          error: null,
        });
        store.updateForm("cardType", response.data.card_type);
        store.updateForm("email", response.data.email);
      } catch (err) {
        setAuth({
          status: "failed",
          data: null,
          error: err.response.data,
        });
      }
    };

    loginMyAccount();

    return false;
  };

  return auth.status === "succeeded" && auth.data?.email ? (
    <Declaration appType="renew" />
  ) : (
    <Layout mType="individual">
      <div className="container mx-auto">
        <div className="lg:py-5 lg:px-0 py-4 px-4">
          <Breadcrumb mType="individual" appType="renew" />

          <h3 className="font-bold text-lg mb-8">Enter your card details:</h3>

          <div class="w-full bg-white rounded-lg large-shadow md:mt-0 sm:max-w-md mx-auto xl:p-0 mb-8">
            <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
              {auth.error && (
                <div
                  class="flex p-4 mb-8 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800"
                  role="alert"
                >
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    className="flex-shrink-0 inline w-5 h-5 mr-3"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                    ></path>
                  </svg>
                  <div className="space-y-2">
                    {Array.isArray(auth.error.message)
                      ? auth.error.message.map((message, i) => (
                          <p key={i}>{message}</p>
                        ))
                      : auth.error.message}
                  </div>
                </div>
              )}

              <form class="space-y-4 md:space-y-6" onSubmit={onSubmit}>
                <div>
                  <label for="username" class="block mb-2 text-gray-900">
                    Lib No:
                    <Popover className="relative inline-block">
                      <Popover.Button className="text-sm focus:outline-none">
                        <svg
                          class="w-6 h-6 inline-block ml-2"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-expanded="false"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          ></path>
                        </svg>
                      </Popover.Button>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0 translate-y-1"
                        enterTo="opacity-100 translate-y-0"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 translate-y-0"
                        leaveTo="opacity-0 translate-y-1"
                      >
                        <Popover.Panel className="absolute left-0 z-10 mt-3 w-screen max-w-sm px-4 sm:px-0">
                          <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                            <div className="relative bg-white p-7">
                              <p className="mb-2">
                                <b>Lib No</b> can be found at the bottom right
                                on the front of your library card.
                              </p>
                              <p>
                                <img src={libNoImage} className="h-48" alt="" />
                              </p>
                            </div>
                          </div>
                        </Popover.Panel>
                      </Transition>
                    </Popover>
                  </label>
                  <input
                    type="text"
                    name="username"
                    id="username"
                    class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3"
                    placeholder="21995"
                    required=""
                    value={loginForm.username}
                    onChange={(e) => onUpdateField("username", e.target.value)}
                  />
                </div>
                <div>
                  <label for="email" class="block mb-2 text-gray-900">
                    Registered E-mail:
                    <Popover className="relative inline-block">
                      <Popover.Button className="text-sm focus:outline-none">
                        <svg
                          class="w-6 h-6 inline-block ml-2"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-expanded="false"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          ></path>
                        </svg>
                      </Popover.Button>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0 translate-y-1"
                        enterTo="opacity-100 translate-y-0"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 translate-y-0"
                        leaveTo="opacity-0 translate-y-1"
                      >
                        <Popover.Panel className="absolute left-0 z-10 mt-3 w-screen max-w-sm px-4 sm:px-0">
                          <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                            <div className="relative bg-white p-7">
                              This is the email address associated with your
                              account. If you are not sure or have forgotten the
                              email address, please contact our staff for
                              assistance.
                            </div>
                          </div>
                        </Popover.Panel>
                      </Transition>
                    </Popover>
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="abc@exampe.org"
                    class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3"
                    required=""
                    value={loginForm.email}
                    onChange={(e) => onUpdateField("email", e.target.value)}
                  />
                </div>
                <div>
                  <label for="captcha" class="block mb-2 text-gray-900">
                    Verification Code:
                  </label>
                  <p className="mb-2 text-gray-500 text-sm">
                    Please enter the verification code below to verify your
                    request.
                  </p>
                  {captcha && (
                    <div className="mb-2 flex">
                      <img src={captcha.img} alt="" />
                      <button
                        className="text-sm ml-4"
                        type="button"
                        onClick={fetchCaptcha}
                      >
                        <svg
                          className="w-4 h-4 inline-block mr-1"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                          ></path>
                        </svg>
                        Refresh
                      </button>
                    </div>
                  )}
                  <input
                    type="text"
                    name="captcha"
                    id="captcha"
                    class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3"
                    required=""
                    value={loginForm.captcha}
                    onChange={(e) => onUpdateField("captcha", e.target.value)}
                  />
                </div>
                <button
                  type="submit"
                  className={clsx(
                    "w-full text-white bg-orange-600 hover:bg-orange-700 focus:ring-4 focus:outline-none focus:ring-primary-300 rounded-lg px-5 py-2.5 text-center",
                    auth.status === "pending"
                      ? "opacity-50 pointer-events-none"
                      : ""
                  )}
                  disabled={auth.status === "pending"}
                >
                  Log in
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
